if (!customElements.get('tab-video')) {
  class TabVideo extends HTMLElement {
    constructor() {
      super();
      this.pcButtons = this.querySelectorAll('[data-pc-btn]');
      this.mbButtons = this.querySelectorAll('[data-mb-btn]');
      this.videos = this.querySelectorAll('[data-video] video');
      this.showVoice = false;
      this.videos[0].play()
    }

    connectedCallback() {
      this.pcButtons.forEach(button => {
        button.addEventListener('click', this.switchVideo.bind(this));
        button.addEventListener('mouseover', this.switchVideo.bind(this));
      });
      this.mbButtons.forEach(button => {
        button.addEventListener('click', this.switchVideo.bind(this));
      });
      this.bindVoiceEvent()
    }
    
    switchVideo(event) {
      var btn = event.currentTarget;
      var videoId = event.currentTarget.dataset.video;
      this.switchVideoBtn(btn);
      this.switchCurVideo(videoId);
    }


    switchVideoBtn(btn) {
      if (btn.classList.contains('tab-btn-active')) {
        return
      }
      this.querySelectorAll('.tab-btn-active').forEach(btn => {
        btn.classList.remove('tab-btn-active')
      });
      btn.classList.add('tab-btn-active');
    }
    
    switchCurVideo(videoId) {
      var newVideoItem = this.querySelector(`.tab-video__item[data-video="${videoId}"]`)
      if (newVideoItem.classList.contains('tab-video-active')) {
        return
      }

      this.querySelectorAll('.tab-video-active').forEach(videoItem => {
        const video = videoItem.querySelector('video')
        if (video) {
          video.pause()
          video.currentTime = 0
        }
        videoItem.classList.remove('tab-video-active')
      });

      newVideoItem.classList.add('tab-video-active');
      const newVideo = newVideoItem.querySelector('video')
      if (newVideo) {
        const videoSource = newVideo.querySelector('source')
        if (!videoSource.src) {
          videoSource.src = videoSource.dataset.src
        }
        setTimeout(() => {
          newVideo.currentTime = 0;
          newVideo.play();
        }, 300)
      }
    }


    bindVoiceEvent() {
      this.querySelectorAll('.tab-video__control').forEach((ele) => {
        ele.addEventListener('click', (evt) => {
          var target = evt.target
          if (!target.classList.contains('icon-sound')) {
            target = target.parentNode
          }
          if (!target.classList.contains('icon-sound')) {
            return
          }
          const isAlreadyActive = target.classList.contains('icon-sound-active') ? true : false
          if (isAlreadyActive) {
            return
          }
          this.showVoice = !this.showVoice

          this.videos.forEach(video => {
            video.muted = !this.showVoice
            if (this.showVoice) {
              video.parentNode.querySelector('.icon-sound_yes').classList.add('icon-sound-active')
              video.parentNode.querySelector('.icon-sound_no').classList.remove('icon-sound-active')
            } else {
              video.parentNode.querySelector('.icon-sound_yes').classList.remove('icon-sound-active')
              video.parentNode.querySelector('.icon-sound_no').classList.add('icon-sound-active')
            }
          })
        })
      })
    }
  }

  customElements.define('tab-video', TabVideo);
}
